module.exports = __webpack_public_path__ + "static/media/resource-3@2x.7e53ceab.jpg";